var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap shadow-lg bg-white rounded"},[_c('secret-question-form',{attrs:{"title":_vm.$t('auth.question.title'),"loading":_vm.loading},on:{"submit":_vm.onSubmit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }